export default __webpack_public_path__ + "img/6e485ebe277b8a17841009199289e469.svg";